module.exports = __webpack_public_path__ + "static/img/nda-sample.31f5085.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/nda-sample.pdf
// module id = K/dk
// module chunks = 73